export const DESIGN_VIEW_PREFIX = "DV_";
export const PLAN_VIEW_PREFIX = "PV_";

export function propGltfFileNameFromName(assetName: string) {
  return DESIGN_VIEW_PREFIX + assetName + ".glb";
}

export function propSvgFileNameFromName(assetName: string) {
  return PLAN_VIEW_PREFIX + assetName + ".svg";
}

export function propDwgFileNameFromName(assetName: string) {
  return PLAN_VIEW_PREFIX + assetName + ".dwg";
}
